export function initHeaderScroll() {
  const header = document.querySelector('.po-header');
  if (!header) return;

  window.addEventListener('scroll', () => {
    header.classList.toggle('po-header_scrolled', window.scrollY > 20);
  });
}
